import { useEffect } from 'react'
import { useLocation }                                             from 'react-router-dom'
import {initAutoTracking, initializeGA, setUserId, trackPageView} from '../util/analytics'

const Analytics = ({user, isAdmin}) => {
	const location = useLocation()

	useEffect(() => {
		initializeGA(process.env.REACT_APP_GTAG) // Initialize GA once when the component mounts
		// blanket click tracking, replacing Mixpanel's autocapture (094)
		return initAutoTracking()
	}, [])

	useEffect(() => {
		setUserId(user?.id)
	}, [user, isAdmin])

	useEffect(() => {
		trackPageView(location.pathname + location.search) // Track page view on location change
	}, [location])

	return null // This component doesn't render anything
}

export default Analytics